import React from 'react';
import '../style.css';

interface TextAreaInputProps {
  name: string;
  placeholder: string;
  width?: string | number;
  height?: string | number;
  value?: string;
  setValue?: (value: string) => void;
  disabled?: boolean;
}

export const TextAreaInput: React.FC<TextAreaInputProps> = (props) => {
  const { name, placeholder, width, height, value, setValue, disabled } = props;
  return (
    <div
      className='generic-text-area-input'
      style={{
        height: height ? height : '100%',
        width: width ? width : '100%',
      }}
    >
      <div className='generic-text-area-input__label'>{name}</div>
      <textarea
        name={name}
        className={'generic-text-area-input__input'}
        placeholder={placeholder}
        value={value}
        onChange={(e: any) => {
          if (setValue) setValue(e.target.value);
        }}
        disabled={disabled}
      />
    </div>
  );
};
